import {createApp} from "vue";
import App from "./App.vue";
import router from "./router";

router.afterEach(() => {
    window.webVitals && window.webVitals.zyCustomContentfulPaint();
});
const app = createApp(App).use(router).mount("#app");
window.Vue = app;
